import { cn } from '../lib/cn';

export function LogoMark({ className, animated = false }: { className?: string; animated?: boolean }) {
  return (
    <svg viewBox="0 0 64 64" className={cn('shrink-0', animated && 'animate-float', className)} aria-hidden>
      <ellipse cx="32" cy="58" rx="9" ry="2.4" fill="currentColor" opacity="0.18" />
      <path
        d="M32 5c-10.5 0-19 8.2-19 18.5 0 13 15.4 26.5 17.1 28a2.9 2.9 0 0 0 3.8 0C35.6 50 51 36.5 51 23.5 51 13.2 42.5 5 32 5z"
        fill="var(--color-primary-500)"
      />
      <path
        d="M26.4 20.4a5.9 5.9 0 1 1 8.3 5.4c-1.7.7-2.7 2.1-2.7 3.8v1.2"
        fill="none"
        stroke="var(--color-ink-900)"
        strokeWidth="4.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="38" r="2.8" fill="var(--color-ink-900)" />
    </svg>
  );
}

const SIZES = {
  sm: { mark: 'size-7', text: 'text-lg' },
  md: { mark: 'size-9', text: 'text-2xl' },
  lg: { mark: 'size-14', text: 'text-4xl' },
  xl: { mark: 'size-20 sm:size-24', text: 'text-5xl sm:text-7xl' },
} as const;

export function Logo({
  size = 'md',
  animated = false,
  className,
}: {
  size?: keyof typeof SIZES;
  animated?: boolean;
  className?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2 select-none', className)}>
      <LogoMark className={SIZES[size].mark} animated={animated} />
      <span className={cn('font-display font-extrabold tracking-tight leading-none', SIZES[size].text)}>
        Ok, <span className="text-primary-500">where?</span>
      </span>
    </span>
  );
}
